import { FilterParams } from '@synergy/models';
import { PoolFilterSearchBar } from '@synergy/components-next';
import { ReactElement, useRef, useState } from 'react';
import { StandardTextFieldProps } from '@mui/material';
import debounce from 'lodash.debounce';

import { useFilter } from '../filter-context';

export interface FilterSearchProps extends StandardTextFieldProps {
    size?: 'small' | 'medium';
}

export const FilterSearch = (props: FilterSearchProps): ReactElement => {
    const { updateFilter, filter } = useFilter();
    const [search, setSearch] = useState(filter.get(FilterParams.Search) ?? '');

    const filterUpdate = (search: string): void => {
        filter.delete(FilterParams.Search);
        if (search) {
            filter.set(FilterParams.Search, search);
        }
        updateFilter(filter);
    };
    const debouncedFilterUpdate = useRef(debounce(filterUpdate, 400)).current;

    const handleSearchChange = (value: string): void => {
        setSearch(value);
        debouncedFilterUpdate(value);
    };

    return (
        <PoolFilterSearchBar
            {...props}
            value={search}
            onChange={handleSearchChange}
            placeholder={props.placeholder}
            size={props.size}
        />
    );
};
